import { Checkbox, FormControlLabel, FormLabel, Grid, withStyles } from '@material-ui/core';
import { useContext, useEffect, useState, useMemo } from 'react';
import AppContext from '../../../App/AppContext';
import CustomeEditor from '../../../Core/CkEditor';
import { Multiselect, SecondaryButton, TextBox } from '../../../Core/FormInput';
import { getUsersDropdown, PostmasterMessage } from '../../../Core/Service/masterMessage-Service';

const AddEditMasterMess = ({ data, onClose }) => {
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        roleIds: data?.userTypeIds || [],
        UserList: [],
        messageID: data?.messageID || null,
        messageIsActive: data?.messageIsActive === 'Yes',
        messageDescription: data?.messageDescription || '',
        messageTitle: data?.messageTitle || ''
    });

    useEffect(() => {
        const fetchData = async () => {
            let res = await getUsersDropdown();
            if (res.success) {
                setState((st) => ({ ...st, UserList: res.data?.userTypes || [] }));
            } else {
                showToast('Failed to fetch Users');
            }
        };
        fetchData();
    }, [showToast]);

    const selectedUsers = useMemo(() => state.UserList.filter((c) => state.roleIds.includes(c.id)), [state.UserList, state.roleIds]);

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setState((st) => ({ ...st, [name]: checked }));
    };
    const handleInput = (event) => {
        const { name, value } = event.target;
        setState((st) => ({ ...st, [name]: value }));
    };

    const handleSubmit = async () => {
        const res = await PostmasterMessage(state);

        if (res.success) {
            showToast('Successfully Updated Master Message');
            onClose();
        } else {
            showToast('Failed to Update Master Message');
        }
    };

    const handleCkeditorState = (name) => (event, editor) => {
        setState((st) => ({ ...st, [name]: editor.getData() }));
    };

    const handleChanges = (e, value) => {
        setState((st) => ({ ...st, roleIds: value.map((c) => c.id) }));
    };
    const GlobalCss = withStyles({
        '@global': {
            '.ck.ck-editor__editable_inline': {
                height: '452px',

                // Tablet
                '@media (max-width: 1024px)': {
                    height: '350px'
                },

                // Mobile
                '@media (max-width: 600px)': {
                    height: '250px'
                }
            }
        }
    })(() => null);

    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={11}>
                <FormLabel component="legend" style={{ marginBottom: 2 }} className="mandatoryfields">
                    Users
                </FormLabel>
                <Multiselect value={selectedUsers} options={state.UserList || []} onChange={handleChanges} />
            </Grid>

            <Grid item style={{ textAlign: 'right' }}>
                <FormControlLabel
                    control={<Checkbox checked={state.messageIsActive} onChange={handleCheckbox} name="messageIsActive" />}
                    label="Is Active?"
                    style={{ marginTop: 10 }}
                />
            </Grid>
            <Grid item xs={12}>
                <FormLabel component="legend" style={{ marginBottom: 2 }} className="mandatoryfields">
                    Title
                </FormLabel>
                <TextBox value={state.messageTitle} options={state.UserList || []} name="messageTitle" placeholder="Title" onChange={handleInput} />
            </Grid>

            <Grid item xs={12}>
                <FormLabel component="legend" className="mandatoryfields">
                    Description
                </FormLabel>
            </Grid>
            <GlobalCss />
            <Grid item xs={12}>
                <CustomeEditor
                    name="messageDescription"
                    onChange={handleCkeditorState('messageDescription')}
                    data={state.messageDescription}
                    placeholder="Description"
                    style={{ height: 300 }}
                />
            </Grid>

            <Grid item xs={12}>
                <SecondaryButton className="Submitbtn" onClick={handleSubmit}>
                    Submit
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AddEditMasterMess;
